import { render, staticRenderFns } from "./ActionTemplate.vue?vue&type=template&id=f68c88f0&lang=pug"
import script from "./ActionTemplate.vue?vue&type=script&lang=js"
export * from "./ActionTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports